import React from 'react';

import { FormattedMessage } from 'react-intl';
import { CloseButton } from './components/CloseButton';
import { LedgerTransaction } from '../../components/icon/Wallet';

export const LedgerTransactionModal = () => {
  const handleClose = () => {
    const popUpElements = document.getElementsByClassName(
      'ledger-transaction-pop-up'
    )?.[0];
    popUpElements.setAttribute('style', 'display:none');
  };

  return (
    <div
      className=" ledger-transaction-pop-up"
      style={{
        zIndex: 999,
        display: 'none',
      }}
    >
      <div className="nws-modal-wrapper open">
        <div className="modal-overlay" onClick={handleClose} />
        <div
          className="modal"
          style={{
            background: '#1d2932',
            minWidth: '280px',
          }}
        >
          <div
            className="modal-header flex justify-end"
            style={{
              display: 'flex',
              justifyContent: 'end',
            }}
          >
            <CloseButton onClick={handleClose} />
          </div>
          <div className="modal-body">
            <div className="flex items-center justify-center my-7 mx-auto w-12">
              <LedgerTransaction />
            </div>

            <div className="flex flex-col items-center text-white mb-4">
              <div className="text-center text-sm">
                <FormattedMessage
                  id="please_confirm_this_transaction_on_ledger"
                  defaultMessage={'Please confirm this transaction on ledger.'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
